import axios from 'axios';
import { CUSTOMER_API_URL } from '../constants';
import { useState, useEffect } from 'react';
import { useEmitMessage } from '../hooks/useEmitMessage';
import { AddSubscriptionLineResponseTypeDefine } from '../types/api/add-subscription-line-api-type';

type CartItem = {
  variantId: string;
  quantity: number;
  sellingPlanId: string;
}

const factoryCreateRequest = (token: string) => {

  return (product: CartItem) => {

    const planId = `gid://shopify/SellingPlan/${product.sellingPlanId}`;
    const variantId = `gid://shopify/ProductVariant/${product.variantId}`;
    const quantity = Number(product.quantity);

    return axios.post(
      `${CUSTOMER_API_URL}?action=addSubscriptionLineToFirstSubscription`,
      {
        planId,
        variantId,
        quantity,
      },
      { headers: { Authorization: token } }
    );
  }
}

export const usePassCartItemsFromParentToSubscription = (
  token: string
) => {
  const [cartProducts, setCartProducts] = useState<CartItem[]>([]);

  const emitSuccessMessage = useEmitMessage();
  const emitErrorMessage = useEmitMessage('keep');
  const createRequest = factoryCreateRequest(token);

  // 親windowからpostMessageで送られてくるカート内商品のハンドリング
  useEffect(() => {
    const handleRecieveMessage = (event: MessageEvent) => {
      const { cartItems } = event.data;
      if (!cartItems || cartItems.length === 0) return;

      setCartProducts(cartItems);
    };
    window.addEventListener('message', handleRecieveMessage);

    return () => window.removeEventListener('message', handleRecieveMessage);
  }, []);

  // カート内商品を受け取った際の処理
  useEffect(() => {

    const requests = cartProducts.map(createRequest);

    (async () => {
      try {
        const results = await Promise.all(requests);
        const isFailedAny = results.some(
          (result) =>
            result.data.status ===
              AddSubscriptionLineResponseTypeDefine.NONE_SUBSCRIPTION ||
            result.data.status ===
              AddSubscriptionLineResponseTypeDefine.API_ERROR
        );
        const message = isFailedAny ? 'app-failed-any' : 'app-success-add';

        emitSuccessMessage(message);

      } catch (error) {
        console.log(error);
        emitErrorMessage('app-error');
      }
    })();
  }, [cartProducts]);

  return cartProducts;
};
